import { render, staticRenderFns } from "./BasketCounter.vue?vue&type=template&id=34e9f3c0&scoped=true"
import script from "./BasketCounter.vue?vue&type=script&lang=js"
export * from "./BasketCounter.vue?vue&type=script&lang=js"
import style0 from "./BasketCounter.vue?vue&type=style&index=0&id=34e9f3c0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34e9f3c0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VTextField})
